import axios from '../config/axiosConfig';
import authService from './authService';
import { API_BASE_URL } from '../config/api';

const PAYROLL_URL = `${API_BASE_URL}/payroll/payrolls/`;

const getHeaders = () => ({
  'Authorization': `Token ${authService.getToken()}`,
  'Content-Type': 'application/json'
});

const payrollService = {
  /**
   * Lists payrolls. Options object rather than positional arguments, the
   * project-wide convention. Empty filters are omitted so the API never
   * receives a blank value to match on.
   */
  listPayrolls: ({
    search = null,
    frequency = null,
    dateField = null,
    dateFrom = null,
    dateTo = null,
    showInactive = false,
    ordering = '-payment_date',
    page = 1
  } = {}) => {
    const params = { ordering, page };

    if (search) params.search = search;
    if (frequency) params.frequency = frequency;
    if (dateField) params.date_field = dateField;
    if (dateFrom) params.date_from = dateFrom;
    if (dateTo) params.date_to = dateTo;
    if (showInactive) params.show_inactive = 'true';

    return axios.get(PAYROLL_URL, { headers: getHeaders(), params });
  },

  getPayrollById: (id) =>
    axios.get(`${PAYROLL_URL}${id}/`, { headers: getHeaders() }),

  createPayroll: (data) =>
    axios.post(PAYROLL_URL, data, { headers: getHeaders() }),

  updatePayroll: (id, data) =>
    axios.patch(`${PAYROLL_URL}${id}/`, data, { headers: getHeaders() }),

  approve: (id) =>
    axios.patch(`${PAYROLL_URL}${id}/approve/`, {}, { headers: getHeaders() }),

  pay: (id) =>
    axios.patch(`${PAYROLL_URL}${id}/pay/`, {}, { headers: getHeaders() }),

  cancel: (id) =>
    axios.patch(`${PAYROLL_URL}${id}/cancel/`, {}, { headers: getHeaders() }),

  /**
   * Downloads the receipt. The blob-to-anchor dance lives here rather than in
   * the page, mirroring clientQuoteService.exportPDF so both documents behave
   * the same for the user.
   */
  exportReceipt: (id) =>
    axios.get(`${PAYROLL_URL}${id}/export_pdf/`, {
      headers: getHeaders(),
      responseType: 'blob'
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        response.headers?.['content-disposition']
          ?.split('filename=')[1]?.replace(/"/g, '') || 'recibo-nomina.pdf'
      );
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    }),
};

export default payrollService;
